import { Block } from 'ui-kit/blocks'
import { Heading, Text } from 'ui-kit/typography'
import { Link } from 'ui-kit/actions'
import { LINKS } from 'routes/constants'
import classes from './PricingHero.module.scss'

export function PricingHero() {
  // const freeTrialTest = useFeatureFlagVariantKey(
  //   'pricing-page-free-trial-conversion',
  // )

  return (
    <Block
      as={'section'}
      variant={'shadowMob'}
      pad={'baseMob'}
      divider={'mobile'}
      className={classes.section}
    >
      <div className={classes.description}>
        <Heading as={'h2'} size={'xl'} center balance>
          Free Proof-of-Concept
        </Heading>
        <Text size={'lg'} center balance className={classes.subtitle}>
          Our team will help you validate requirements and build a working
          prototype of integrations for your use case completely free.
        </Text>
      </div>
      <Link
        href={LINKS.PROOF_OF_CONCEPT}
        type={'secondary'}
        asPageButton
        className={classes.link}
      >
        Learn more about the PoC
      </Link>
    </Block>
  )
}
